import React from 'react';
import ButtonBase, { ButtonProps as MUIButtonProps } from '@mui/material/Button';

type ButtonProps = MUIButtonProps & {
  label?: React.ReactNode;
};

const Button: React.FC<ButtonProps> = ({
  label,
  children,
  variant = 'outlined',
  size = 'large',
  disabled = false,
  type = 'button',
  ...rest
}) => {
  return (
    <ButtonBase variant={variant} size={size} disabled={disabled} type={type} {...rest}>
      {label ?? children}
    </ButtonBase>
  );
};

export default Button;
